import React, { useState, useEffect } from "react";
import axios from "axios";
import AdminSidebar from "../../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../../component/AdminComp/AdminTopbar";
import { baseurl, imageUrl } from "../../../Baseurl"; // Ensure baseurl is defined
import Swal from "sweetalert2"; // Import SweetAlert2
import { Link, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const ReportNavbar = () => {
  return (
    <>
      <div>
        <div className="text-start mb-2">
          <Link to="/admin/seller-report" className="nacs me-2">
            Seller Report
          </Link>
          <Link to="/admin/customer-report" className="nacs me-2">
            Customer Report
          </Link>
        </div>
      </div>
    </>
  );
};

export default ReportNavbar;
